import React, { useEffect, useState } from 'react';

import ConfirmDialog from '../modules/Whatsapp/components/ConfirmDialog';
import { onLeaveRequest } from './leaveGuard';

// Окно «Изменения не сохранены» при уходе с формы. Стоит один раз рядом с роутами (Root) и
// отвечает роутеру: «Остаться» отменяет переход, «Уйти без сохранения» его выполняет.
function LeaveDialog() {
  const [request, setRequest] = useState(null);

  useEffect(() => onLeaveRequest(setRequest), []);

  const answer = (leave) => {
    if (!request) return;
    const { callback } = request;
    setRequest(null);
    callback(leave);
  };

  return (
    <ConfirmDialog
      open={Boolean(request)}
      title="Изменения не сохранены"
      text={request ? request.message : ''}
      confirmLabel="Уйти без сохранения"
      cancelLabel="Остаться"
      confirmColor="secondary"
      onConfirm={() => answer(true)}
      onClose={() => answer(false)}
    />
  );
}

export default LeaveDialog;
